import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Text } from '@rsos/base-components';
import { APP_TYPE_APP_LAUNCH } from '@rsos/constants/appLauncherTypes';
import { useFlag } from '@rsos/flags';
import useHasAccessToAirAmbulance from '@rsos/hooks/useHasAccessToAirAmbulance';
import { setSelectedTool } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import {
  TOOLS_TAB,
  AIR_AMBULANCE_TOOL,
  ALI_DISCREPANCY_TOOL,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import {
  trackRequestAirAmbulanceClick,
  AIR_AMBULANCE_SOURCE_BUTTON,
} from '../../../../gainsightTrackings/airAmbulanceTrackings';
import AirAmbulanceForm from '../../../AirAmbulanceForm';
import { AliDiscrepancyForm } from '../../../discrepancies';
import AirAmbulanceCard from '../AirAmbulance';
import ExternalLinkCards from '../ExternalLinkCards';
import CollaboratorBanner from './CollaboratorBanner';

/**
 * The Tool tab of the EventPane
 */
const ToolsTab = () => {
  const hasAccessToAirAmbulance = useHasAccessToAirAmbulance();
  const hasAirAmbulanceEnabled = useFlag('air_ambulance');

  const applications = useSelector(state => state.appLauncher.applications);

  const dispatch = useDispatch();
  const selectedTool = useSelector(state => state.eventPane.selectedTool);

  const handleSelectAirAmbulance = () => {
    dispatch(setSelectedTool({ tool: AIR_AMBULANCE_TOOL }));
    trackRequestAirAmbulanceClick({
      sourceButton: AIR_AMBULANCE_SOURCE_BUTTON.TOOLS_TAB,
    });
  };

  const externalLinkApplications = useMemo(
    () =>
      applications?.filter(
        app =>
          app.type === APP_TYPE_APP_LAUNCH &&
          (app.details.launch_global || app.details.launch_call),
      ) || [],
    [applications],
  );

  const showTabContent = useMemo(() => {
    if (!externalLinkApplications.length) {
      return false;
    }

    return true;
  }, [externalLinkApplications]);

  if (selectedTool?.tool === AIR_AMBULANCE_TOOL) {
    return (
      <Box>
        <AirAmbulanceForm />
      </Box>
    );
  }

  if (selectedTool?.tool === ALI_DISCREPANCY_TOOL) {
    return (
      <Box>
        <AliDiscrepancyForm toolProperties={selectedTool?.toolProperties} />
      </Box>
    );
  }

  return showTabContent ? (
    <Box horizontal flexDirection="row" flexWrap="wrap" gridGap="16px">
      <CollaboratorBanner />

      <ExternalLinkCards externalLinkApplications={externalLinkApplications} />
      {hasAccessToAirAmbulance && hasAirAmbulanceEnabled && (
        <AirAmbulanceCard
          tab={TOOLS_TAB}
          handleClick={handleSelectAirAmbulance}
        />
      )}
    </Box>
  ) : (
    <Box>
      <Text textAlign="center" color="secondaryText">
        No tools available
      </Text>
    </Box>
  );
};

export default ToolsTab;
